import { inject } from '@angular/core';
import { withCrudSingleEvents } from '@indutrust/shared-util';
import { signalStore } from '@ngrx/signals';
import { CompanyApiClient } from '../company-api-client.service';
import { companySingleEvents } from './company-detail.events';

/**
 * Signal store for a single {@link import('@indutrust/shared-model').Company}
 * entity view.
 *
 * Drives detail/edit screens by wiring `loadById`, `edit` and `delete` against
 * {@link CompanyApiClient}. Exposes per-operation status signals
 * (`loadByIdLoading`, `editLoading`, `deleteLoading`, `anyLoading`).
 *
 * Use alongside {@link companySingleEvents} — dispatch `loadByIdRequested`
 * from a component to populate the detail view.
 *
 * @example
 * const dispatch = injectDispatch(companySingleEvents);
 * dispatch.loadByIdRequested({ id: 42 });
 */
export const CompanyDetailStore = signalStore(
  { providedIn: 'root' },
  withCrudSingleEvents(companySingleEvents, () => inject(CompanyApiClient))
);
